import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-tag',
  templateUrl: './new-tag.component.html',
  styleUrls: ['./new-tag.component.css']
})
export class NewTagComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
